export default "__VITE_ASSET__c3411ab3__"